import { flexCenter, media } from '@anm/styles/helpers';
import { FC } from 'react';
import styled from 'styled-components';

export type MyVideosTitleProps = {
  className?: string;
  onClick?: (...arg: any[]) => void;
};

const myVideosTitleWrapperResponsive = media.tablet`
    padding: 0;
`;

export const MyVideosTitleWrapper = styled.div`
  ${flexCenter};
  justify-content: flex-start;
  ${myVideosTitleWrapperResponsive};
`;

const MyVideosTitle: FC<MyVideosTitleProps> = ({ className, onClick }) => (
  <MyVideosTitleWrapper {...{ className, onClick }}>
    <span>Projects</span>
  </MyVideosTitleWrapper>
);

export default MyVideosTitle;
